<template>
  <div class="meeting">
    <div class="top">
      <h2>类型：</h2>
      <span class="active">会议</span>
    </div>
    <div
      class="item-box"
      v-for="item in itemList3"
      :key="item.id">
      <div class="img-box">
        <img class="img" :src="$global.imgUrl + item.cover" alt="">
      </div>
      <div class="content-box">
        <div class="title" @click="goDetail(item)" v-html="item.title"></div>
        <div class="unit-box">
          <img src="@/assets/img/qietu/meetIcon.png" alt="">
          <span style="color: #3C4F83;font-weight: bold;">主办单位：</span>
          <span class="unitText" v-for="v in item.orgs" :key="v.id">{{v.type === 2 ? v.name : ''}} </span>
        </div>
        <div class="tiem-box">
            <div style="margin-right:37px;">
              <img src="@/assets/img/qietu/meetIcon2.png" alt="">
              <span style="color: #3C4F83;font-weight: bold;">时间：</span>
              <span>{{item.beginTime.slice(0,10)}}</span>
            </div>
            <div>
              <img src="@/assets/img/qietu/meetIcon1.png" alt="">
              <span style="color: #3C4F83;font-weight: bold;">地点：</span>
              <span>{{item.province}} {{item.city}} {{item.address}}</span>
            </div>
        </div>
        <ul class="icon" style="margin-top: 13px">
          <li @click.stop="collect(item.id)">
            <img
              v-if="item.collect"
              src="@/assets/img/qietu/sc.png"
              alt=""
            />
            <img v-else src="@/assets/img/qietu/kongxin.png" alt="" />
            <span>收藏</span>
          </li>
          <li class="share">
            <img src="@/assets/img/qietu/share.png" alt="" />
            <div>分享</div>
            <ul class="share_box">
              <div class="sanjiao"></div>
              <li @mouseover.stop="weChat(item.id)" class="weChat">
                <img src="@/assets/img/details/WeChat.png" alt="" />
                <div>微信</div>
                <div
                  :id="`WXqrcode${item.id}`"
                  :ref="`WXqrcode${item.id}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="weibo(item)">
                <img src="@/assets/img/details/weiBo.png" alt="" />
                <div>新浪微博</div>
              </li>
              <li @mouseover.stop="qq(item.id)" class="qq">
                <img src="@/assets/img/details/QQ.png" alt="" />
                <div>QQ</div>
                <div
                  :id="`QQqrcode${item.id}`"
                  :ref="`QQqrcode${item.id}`"
                  class="ma"
                ></div>
              </li>
              <li @click.stop="space(item)">
                <img src="@/assets/img/details/qqspace.png" alt="" />
                <div>QQ空间</div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <Paging
      :total="total"
      :curPage="curPage"
      :limit="limit"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Paging from "@/components/paging";
export default {
  components: {
    Paging,
  },
  data() {
    return {
      WXurl: "",
      QQurl: "",
      isWXId: '',
      isQQId: '',
      // 分页
      curPage: 1,
      total: 0,
      limit: 0,
      itemList3: [], // 征稿函列表
    };
  },
  created() {
    this.getUserCollectMeetingList();
  },
  methods: {
    // 转发微博
    weibo(obj) {
      let url = encodeURIComponent(window.location.href);
      let srcUrl = `pic=${this.$global.imgUrl + obj.cover}`;
      window.open(
        `https://service.weibo.com/share/share.php?${srcUrl}&url=${url}&&title=${obj.title}`
      );
    },
    // 转发到QQ空间
    space(obj) {
      let url = encodeURIComponent(window.location.href);
      let srcUrl = `pics=${this.$global.imgUrl + obj.cover}`;
      window.open(
        `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${srcUrl}&url=${url}&&title=${obj.title}`
      );
    },
    // 微信二维码
    weChat(id) {
      if (this.isWXId === id || this.$refs["WXqrcode" + id][0].title) return // 防止重复调用二维码
      this.isWXId = id
      this.WXurl = this.$global.url1 + `meetingDetails?id=${id}`;
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.qr = new QRCode("WXqrcode" + id, {
          width: 150,
          height: 150, // 高度
          text: this.WXurl, // 二维码内容
        });
      });
    },
    // QQ二维码
    qq(id) {
      if (this.isQQId === id || this.$refs["QQqrcode" + id][0].title) return // 防止重复调用二维码
      this.isQQId = id
      this.QQurl = this.$global.url1 + `meetingDetails?id=${id}`;
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.qr = new QRCode("QQqrcode" + id, {
          width: 150,
          height: 150, // 高度
          text: this.QQurl, // 二维码内容
        });
      });
    },
    // 收藏
    async collect(id) {
      let obj = {
        action:  0,
        articleId: id,
        articleType:8,
      };
      await this.$apis.recomendServe.CollectItem(obj);
      this.$Message.success('取消收藏成功')
      await this.getUserCollectMeetingList();
    },
    // 分页
    handlePager(newPage) {
      this.curPage = newPage;
      this.getUserCollectMeetingList();
      document.documentElement.scrollTop = 0;
    },
    // 获取收藏列表
    async getUserCollectMeetingList() {
      const resp = await this.$apis.userServe.getUserCollectMeetingList({pageSize: 5,pageNo: this.curPage});
      if (resp.data) {
        this.total = +resp.data.total;
        this.limit = +resp.data.pageSize;
        this.itemList3 = resp.data.list;
      }
    },
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/meetingDetails",
        query: {
          id: e.id,
          type: 8,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting {
  width: 1200px;
  .top {
    display: flex;
    margin: 40px 0;
    h2 {
      vertical-align: middle;
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
    span {
      margin: 0 10px;
      cursor: pointer;
      &.active {
        color: #0101f3;
      }
    }
  }
  .item-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 20px 45px;
    min-height: 160px;
    background: #fff;
    .img-box {
      margin-right: 10px;
      width: 240px;
      height: 165px;
      background: rgb(244, 244, 244);
      .img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .content-box {
      flex: 1;
      overflow: hidden;
      .title {
        font-size: 18px;
        vertical-align: middle;
        color: #263d78;
        cursor: pointer;
      }
      .unit-box {
        margin: 20px 0;
        width: 100%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        img {
          margin-right: 5px;
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
      }
      .tiem-box {
        display: flex;
        img {
          margin-right: 5px;
          width: 20px;
          height: 20px;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
      }
      .icon {
        display: flex;
        margin-top: 20px;
        height: 37px;
        background: #ffffff;
        li {
          border: 1px solid #dfe8f2;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          padding: 10px;
          box-sizing: border-box;
          cursor: pointer;
          &:not(:last-child) {
            border-right: none;
          }
          img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
          }
        }
        .readBtn {
          border: 1px solid #dfe8f2;
          border-radius: 0;
          height: 100%;
          img {
            width: 20px;
            height: 20px;
            margin-right: 6px;
            vertical-align: middle;
          }
          &:focus {
            box-shadow: none !important;
          }
        }
        .share:hover {
          .share_box {
            display: block;
          }
        }
        .share {
          position: relative;
          .share_box {
            cursor: pointer;
            display: none;
            right: -133px;
            top: -130px;
            position: absolute;
            width: 133px;
            height: 167px;
            background: #ffffff;
            box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
            border-radius: 10px;
            .weChat:hover {
              .ma {
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 99;
              }
            }

            .weChat {
              position: relative;
              .ma {
                display: none;
                left: 123px !important;
                position: absolute !important;
                width: 200px !important;
                top: -10px !important;
                height: 167px !important;
                background: white !important;
                box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
                border-radius: 10px;
              }
            }
            .qq:hover {
              .ma {
                display: flex;
                justify-content: center;
                align-items: center;
              }
            }
            .qq {
              position: relative;
              .ma {
                display: none;
                left: 123px !important;
                position: absolute !important;
                width: 200px !important;
                top: -90px !important;
                height: 167px !important;
                background: white !important;
                box-shadow: 3px 1px 7px 0px rgba(8, 8, 64, 0.23);
                border-radius: 10px;
              }
            }
            li {
              border: none;
              margin-top: 10px;
              margin-bottom: 0px;
              //display: flex;
              flex-wrap: nowrap;
              //background: pink;
              justify-content: center;
              align-items: center;
              width: 133px;
              height: 30px;

              div {
                width: 60px;
                //background: yellow;
                margin-left: 10px;
              }
              img {
                width: 20px;
                height: 20px;
              }
            }
            .sanjiao {
              width: 0;
              height: 0;
              border-top: 3px solid transparent;
              border-right: 6px solid #fff;
              position: absolute;
              top: 50%;
              margin-top: -3px;
              left: -6px;
              border-bottom: 3px solid transparent;

              //background: pink;
            }
          }
        }
      }
    }
  }
}
</style>
